export const es = {
  landing: {
    title: 'Inicia sesión en tu cuenta',
    signin: 'Inicia sesión con Google',
  },
  lease: {
    back: 'Volver',
    viewLease: 'Ver contrato',
    applicant: {
      addNewTab: '+ Agregar nuevo solicitante',
      addNewTitle: 'Agregar nuevo solicitante',
      name: 'Nombre',
      email: 'Correo electrónico',
      householdStatus: 'Estado del hogar',
      invalidEmail: 'Por favor ingresa un correo electrónico válido',
      addButton: 'Agregar solicitante',
      successAdded: 'Solicitante agregado correctamente.',
      errorAdd: 'No se pudo agregar el solicitante',
    },
    resident: {
      title: 'Residente',
      name: 'Nombre:',
      email: 'Correo electrónico:',
      phone: 'Número de teléfono:',
      leasingFrom: 'Arrendando desde:',
      password: 'Contraseña:',
      loginAsUser: 'Iniciar sesión como usuario',
      loginAsOpening: 'Abriendo…',
      loginAsSuccess: 'Portal del residente abierto en una pestaña nueva (solo lectura, 15 min; pagos deshabilitados).',
      loginAsFailed: 'No se pudo abrir la sesión.',
      lastLogin: 'Último inicio de sesión',
      registered: 'Registrado en TenantPort',
      editingEmail: 'Este nuevo correo electrónico se actualizará automáticamente en Resman.',
      outsync: 'Los datos están actualmente desincronizados con Resman',
      ssnVerified: 'SSN verificado en TenantPort',
      credbuild: 'optar por no CredBuild',
      removeSSN: 'Eliminar requisito de SSN',
      resetPassword: 'Restablecer contraseña',
      inviteSent: 'Invitación enviada:',
      invitationSent: 'Invitación enviada',
      inviteResent: '¡Invitación reenviada!',
      resendInvitation: 'Reenviar invitación',
      sendInvitation: 'Enviar invitacion',
      inviteLink: 'Enlace de invitación:',
      copyInviteLink: 'Copiar enlace de invitación',
      linkCopied: 'Enlace de invitación copiado al portapapeles',
      linkCopyFailed: 'No se pudo copiar el enlace',
      inviteLinkEmailHint:
        'Solo es necesario si el solicitante no recibió el correo de invitación. Envíele este enlace por correo, no por mensaje de texto; es largo y a menudo se rompe o se bloquea en los mensajes de texto.',
      residentInfo: 'Para editar los detalles del residente, actualice en Resman, luego presione sincronizar para mostrar los cambios',
      sync: 'Sync w/Resman',
      applicationStatus: 'Estado de Envío de Solicitud',
      resumeLink: 'Reanudar solicitud:',
      copyResumeLink: 'Copiar enlace para continuar',
      resumeLinkCopied: 'Enlace para continuar copiado.',
      resumeLinkCopyFailed: 'No se pudo copiar el enlace para continuar.',
      resumeLinkHint:
        'Envíe esto para que el solicitante continúe donde lo dejó. Prefiera el correo: los enlaces largos suelen romperse o bloquearse en mensajes de texto.',
      status: 'Estado:',
      loginOnOtherLease: 'Este inicio de sesión está conectado actualmente a {{name}}, no a la persona de este arrendamiento.',
      accountsForEmail: 'Cuentas para este correo',
      showAccounts: 'Mostrar cuentas',
      hideAccounts: 'Ocultar cuentas',
      associationsTitle: 'Asociaciones de correo',
      associationsSubtitle: 'Inicios de sesión y personas de ResMan para {{email}}',
      associationsLoadFailed: 'No se pudieron cargar las asociaciones de correo.',
      associationsEmpty: 'No se encontraron otras cuentas para este correo.',
      associationsLogin: 'Inicio de sesión',
      associationsPaymentSummary: '{{count}} método(s) de pago · Autopago {{autopay}}',
      associationsAutopayOn: 'activo',
      associationsAutopayOff: 'inactivo',
      associationsCredBuildWarning: 'Cuenta CredBuild abierta en la persona vinculada — permanecerá en ese arrendamiento.',
      associationsNoPerson: 'El inicio de sesión no tiene persona vinculada.',
      associationsOtherPersons: 'Otras personas de ResMan (sin inicio de sesión)',
      associationsThisResident: 'este residente',
      associationsNoLeases: 'Sin arrendamientos en esta persona',
      associationsOpenCredBuild: 'CredBuild abierto',
      connectLogin: 'Conectar inicio de sesión',
      connectLoginToThisResident: 'Conectar este inicio de sesión a este residente',
      rebindTitle: '¿Conectar inicio de sesión a este residente?',
      rebindBody: 'Reconectar {{email}} de {{from}} a {{to}}. Auth0 no cambia; el residente conserva su contraseña.',
      rebindUnknownPerson: 'otra persona',
      rebindPaymentWarning: 'Se eliminarán {{count}} método(s) de pago y se desactivará el autopago. El residente deberá agregar un método de pago de nuevo.',
      rebindCredBuildWarning: 'Una cuenta CredBuild abierta en el arrendamiento anterior permanecerá allí y no se moverá con este inicio de sesión.',
      rebindMoveLoginRequired: 'Este inicio de sesión sigue en un arrendamiento activo. El motivo debe comenzar con MOVE_LOGIN (solo super-admin).',
      rebindReasonLabel: 'Motivo',
      rebindReasonHint: 'Requerido para la auditoría (3–500 caracteres).',
      rebindConfirm: 'Conectar inicio de sesión',
      rebindSuccess: 'Inicio de sesión conectado a este residente.',
      rebindFailed: 'No se pudo conectar el inicio de sesión a este residente.',
      moveOutDate: 'Fecha de salida:',
    },
    payment: {
      title: 'Información de pago',
      empty: 'No hay métodos de pago',
      autoPay: 'Pago automático',
      autoPayDate: 'Fecha de pago automático',
      on: 'Activado',
      off: 'Desactivado',
      status: 'Estado del pago en línea',
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
      certifiedFunds: 'Solo fondos certificados',
      description: 'Los pagos en línea han sido deshabilitados debido a intentos fallidos. Por favor, contacta a tu RM para cambiar este estado.',
    },
    transaction: {
      title1: 'Libro mayor de Resman',
      title2: 'Transacciones',
      empty: 'No hay transacciones',
      viewAll: 'Ver todo',
    },
    request: {
      title: 'Solicitudes',
      empty: 'No hay órdenes de trabajo',
    },
    password: {
      resetTitle: '¿Está seguro de que desea restablecer su contraseña?',
      resetDescription: 'Recibirán un correo electrónico pidiéndoles que creen una nueva contraseña.',
      resetPassword: 'Restablecer Contraseña',
      changeTitle: 'Cambiar la Contraseña del Inquilino',
      changeDescription:
        'Esto le permite cambiar la contraseña en nombre del inquilino. Por favor, asegúrese de notificar al inquilino sobre la nueva contraseña.',
      changePassword: 'Cambiar Contraseña',
      credbuildTitle: '¿Está seguro de que desea deshabilitar y finalizar la suscripción a CredBuild del inquilino?',
      credbuildDescription: 'Esto tendrá efecto en el ciclo de facturación del próximo mes.',
    },
    success: {
      invite: 'Se ha reenviado la invitación a {{ property }}',
    },
  },
  logout: {
    title: 'Cerrar Sesión',
    description: '¿Está seguro de que desea cerrar sesión?',
    return: 'Volver',
  },
  pagination: {
    rowsPerPage: 'Filas por página',
  },
  properties: {
    title: 'Buscar Residentes',
    unitNumber: 'Número de Unidad',
    current: 'Actual',
    renewed: 'Renovado',
    pending: 'Pendiente',
    pendingTransfer: 'Transferencia Pendiente',
    former: 'Antiguo',
    evicted: 'Desalojado',
    underEviction: 'Bajo Desalojo',
    search: 'Seleccione un número de unidad para comenzar su búsqueda',
    residentName: 'Nombre(s) del Residente(s)',
    status: 'Estado del Arrendamiento',
    ssnVerified: 'SSN Verificado en TP',
    registered: 'Registrado en TP',
    startDate: 'Fecha de Inicio del Arrendamiento',
    endDate: 'Fecha de Fin del Arrendamiento',
    empty: 'No hay residentes según ese criterio de búsqueda.',
    emptySearchWithUnit: 'No hay residentes para la Unidad {{ unit }} según ese criterio de búsqueda.',
  },
  applicationDetail: {
    title: 'Solicitud',
    backToReports: 'Volver a Solicitantes',
    forbidden: 'No tiene acceso a esta solicitud.',
    notFound: 'Solicitud no encontrada.',
    loadError: 'No se pudo cargar esta solicitud.',
    hasLease: 'Esta solicitud tiene un contrato de arrendamiento.',
    viewLease: 'Ver contrato',
    submissionError: 'Error de envío',
    paymentSucceeded: 'Pago exitoso',
    paymentSucceededGuidance:
      'El pago se realizó correctamente. No le pida al solicitante que envíe otro pago; comuníquese con el soporte de TenantPort para resolver el error de envío.',
    submissionErrorGuidance: 'Comuníquese con el soporte de TenantPort para resolver el error de envío.',
    applicant: 'Solicitante',
    email: 'Correo electrónico',
    mobilePhone: 'Teléfono móvil',
    householdStatus: 'Estado del hogar (rol)',
    property: 'Propiedad',
    unit: 'Unidad',
    moveInDate: 'Fecha de mudanza',
    leaseTerm: 'Plazo del contrato',
    rent: 'Renta',
    selectionTitle: 'Selección de la solicitud',
    selectionDescription:
      'Cambie la fecha de mudanza para cargar las unidades disponibles y los plazos con precio, luego guarde. Usa los mismos datos de disponibilidad que el portal de residentes.',
    selectionLeaseQueued: 'Selección guardada. Se encoló la creación del contrato.',
    creatingLease: 'Selección guardada. Creando el contrato… esta página se actualizará al terminar.',
    selectUnit: 'Seleccionar unidad',
    selectLeaseTerm: 'Seleccionar plazo',
    selectLeaseTermToContinue: 'Seleccione un plazo de contrato para continuar.',
    unitAvailableFrom: 'Unidad disponible desde {{date}}',
    loadingAvailability: 'Cargando unidades y plazos disponibles…',
    availabilityLoadError: 'No se pudieron cargar las unidades disponibles para esta fecha de mudanza.',
    noUnitsForDate: 'No hay unidades disponibles para la fecha de mudanza seleccionada. Pruebe con otra fecha.',
    unitNotAvailable: 'La unidad {{unit}} no está disponible. Puede estar arrendada o la fecha está fuera de su ventana de precios.',
    unitNoTerms: 'Esta unidad no está disponible para la fecha de mudanza seleccionada. Pruebe con otra fecha.',
    selectionSaved: 'Selección de la solicitud guardada.',
    selectionSavedAndRetried: 'Selección guardada. Se volvió a encolar la finalización.',
    selectionSaveFailed: 'No se pudo guardar la selección de la solicitud.',
    selectionRetryNotice: 'Esta solicitud pagada falló al finalizar. Guardar una selección válida reabrirá la finalización y encolará otro intento.',
    status: 'Estado de la solicitud',
    submissionStatus: 'Estado de envío',
    paymentStatus: 'Estado del pago',
    finalizationState: 'Estado de finalización',
    leaseRecord: 'Registro de contrato',
    applicationDate: 'Fecha de solicitud',
    lastUpdated: 'Última actualización',
    roster: 'Miembros del hogar (según lo enviado)',
    rosterName: 'Nombre',
    rosterRole: 'Rol / Parentesco',
    rosterEmail: 'Correo electrónico',
    rosterOwnRecord: '¿Registro propio?',
    rosterThisApp: 'Esta solicitud',
    rosterNotYet: 'Aún no',
    minorSuffix: '(menor)',
    rosterNote: 'De la solicitud misma: los registros y accesos individuales no se crean hasta que se finaliza el contrato.',
    submittedApplication: 'Solicitud enviada',
    submittedApplicationSubtitle: 'Vista de solo lectura de todo lo que ingresó el solicitante, tal como lo envió.',
    submittedApplicationEmpty:
      'Este solicitante no ingresó ningún detalle de la solicitud en este registro. Puede ser un duplicado; revise sus otras solicitudes a continuación.',
    otherApplications: 'Otras solicitudes del solicitante',
    otherAppsProperty: 'Propiedad',
    otherAppsStatus: 'Estado',
    otherAppsData: 'Tiene datos',
    otherAppsLease: 'Contrato',
    otherAppsView: 'Ver',
    otherAppsYes: 'Sí',
    otherAppsNote: 'Mismo solicitante, otros registros de solicitud. Una fila completada o con contrato aquí suele indicar que esta es un duplicado.',
  },
  common: {
    cancel: 'Cancelar',
    save: 'Guardar',
    reset: 'Restablecer',
    change: 'Cambiar',
    close: 'Cerrar',
    success: 'Éxito',
    pending: 'Pendiente',
    skipped: 'Omitido',
    failed: 'Fallido',
    notRequired: 'No requerido',
    default: 'Predeterminado',
    disable: 'Desactivar',
  },
};
